import { useEffect, useState } from 'react';

export const useRefreshable = (onRefresh) => {
  const [refresh, setRefresh] = useState(true);

  useEffect(() => {
    if (refresh) {
      onRefresh();
      setRefresh(false);
    }
  }, [refresh]);

  return () => {
    setRefresh(true);
  };
};
